import { FC } from 'react';
import { Control } from 'react-hook-form';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Form } from '@/_shared/components/Form';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { DialogContactsFormValues } from './types';

type Props = {
  control: Control<DialogContactsFormValues>;
  gap: number;
  firstName: string | undefined;
  lastName: string | undefined;
  email: string | undefined;
};

export const ContactMeFields: FC<Props> = ({ control, gap, firstName, lastName, email }) => {
  const t = useTranslations('core.dialogContacts');
  const { isMobile } = useBreakingPoints();

  return (
    <Box mt='s' display='flex' flexDirection='column' style={{ gap }}>
      <Typography variant='p2' color='primary/text'>
        {t('contactMe.header')}
      </Typography>
      <Box display='flex' flexDirection={isMobile ? 'column' : 'row'} style={{ gap }}>
        <Box flex={1}>
          <Typography variant='p3/light' color='grey/light' mb='xxs'>
            {t('fields.firstName')}
          </Typography>
          <Typography variant='p2/bold' color='primary/text'>
            {firstName ?? '-'}
          </Typography>
        </Box>
        <Box flex={1}>
          <Typography variant='p3/light' color='grey/light' mb='xxs'>
            {t('fields.lastName')}
          </Typography>
          <Typography variant='p2/bold' color='primary/text'>
            {lastName ?? '-'}
          </Typography>
        </Box>
        <Box flex={1}>
          <Typography variant='p3/light' color='grey/light' mb='xxs'>
            {t('fields.email')}
          </Typography>
          <Typography variant='p2/bold' color='primary/text'>
            {email ?? '-'}
          </Typography>
        </Box>
      </Box>
      <Box height={1} bg='grey/light/background' my='s' />
      <Box>
        <Form.FormTextArea
          // @ts-ignore react-hook-form generic mismatch with FieldValues
          control={control}
          name='message'
          placeholder={t('fields.messagePlaceholder')}
          label={t('fields.messageOptional')}
          labelVariant='p3/light'
          textColor='white'
          labelProps={{ mb: 'xs', color: 'grey/light' }}
          bg='primary/background'
        />
      </Box>
    </Box>
  );
};
